
import React, { useState, useEffect } from "react";
import Select from "react-select";
import api from "../../api/api";
import { getSessionUsername } from "../../utils/sessionUser";

function CancelListpage({ setView, setCancelList }) {
  const [docTypeOptions, setDocTypeOptions] = useState([]);
  const [docType, setDocType] = useState(null);

  const [docNoOptions, setDocNoOptions] = useState([]);
  const [docNo, setDocNo] = useState(null);

  const [reasonOptions, setReasonOptions] = useState([]);
  const [reason, setReason] = useState(null);

  const [remark, setRemark] = useState("-");
  const [rows, setRows] = useState([]);
  const [user] = useState(1);

  const [cancelByOptions, setCancelByOptions] = useState([]);
  const [cancelBy, setCancelBy] = useState(null);

  // Load dropdowns
  useEffect(() => {
    if (!user) return;
    api
      .GetCancelDocTypeAPI(user)
      .then((res) => {
        setDocTypeOptions(
          Array.isArray(res.Table)
            ? res.Table.map((item) => ({
              value: item.CanId,
              label: item.DocType,
            }))
            : []
        );
        setReasonOptions(
          Array.isArray(res.Table2)
            ? res.Table2.map((item) => ({
              value: item.Reasonid,
              label: item.Reason,
            }))
            : []
        );
        setCancelByOptions(
          Array.isArray(res.Table1)
            ? res.Table1.map((item) => ({
              value: item.Eid,
              label: item.Ename,
            }))
            : []
        );
      })
      .catch((err) => console.error(err));
  }, [user]);

  // Process
  const handleProcess = () => {
    if (!docType) {
      alert("Please select a DocType");
      return;
    }

    api
      .GetCancelDocNoAPI(docType.label, user)
      .then((res) => {
        const options = Array.isArray(res.Table)
          ? res.Table.map((item) => {
            const details = [item.RefNo, item.VCode, item.VName].filter(Boolean).join(" - ");
            return {
              value: item.DocId,
              label: details ? `${item.DocNo} - ${details}` : item.DocNo,
              docDate: item.DocDate,
              refNo: item.RefNo,
              rawDocNo: item.DocNo   // keep original if needed
            };
          })
          : [];
        setDocNoOptions(options);
        setDocNo(null);
      })
      .catch((err) => console.error(err));
  };

  // Verify
  const handleVerify = () => {
    if (!docType || !docNo) {
      alert("Please select DocType and DocNo");
      return;
    }

    api
      .CancelDetailsAPI(docNo.value, docType.label, user)
      .then((res) => {
        let cancelData = res.CancelDetailsAPIjs;

        if (typeof cancelData === "string") {
          try {
            cancelData = JSON.parse(cancelData);
          } catch (e) {
            console.error("Error parsing CancelDetailsAPIjs:", e);
            cancelData = { Table: [] };
          }
        }

        const tableArray = Array.isArray(cancelData?.Table)
          ? cancelData.Table
          : [];
        const tableData = tableArray.map((item) => ({
          DocId: item.DocId ?? "-",
          DocNo: item.DocNo ?? "-",
          DocDate: item.DocDate ?? "-",
          Rel_PrimeId: item.Rel_PrimeId ?? "-",
        }));

        setRows(tableData);
      })
      .catch((err) => console.error(err));
  };

  // Delete
  const handleDelete = () => {
    if (!docType || !docNo) {
      alert("Please select DocType and DocNo");
      return;
    }

   const formatDate = (d) => {
  if (!d) return "";
  const parts = d.split("/");
  if (parts.length !== 3) return d;
  return `${parts[2]}-${parts[1]}-${parts[0]}`; // yyyy-mm-dd
};

const cancelData = {
  SqlAction: "INSERT", // ✅ FIXED (CAPS)
  DocType: docType.label,
  UserId: user,
  UserName: getSessionUsername(),

  CancelById: cancelBy ? cancelBy.value : user,
  CancelBy: cancelBy ? cancelBy.label : getSessionUsername(),

  PrimeId: String(docNo.value), // ✅ ensure string
  PrimeNo: docNo.rawDocNo || docNo.label.split(" - ")[0], // ✅ clean

  Particular1: formatDate(docNo.docDate), // ✅ safe format
  Particular2: docNo.refNo || "", // ✅ NO NULL

  CanNotes: (remark || "-").substring(0, 50), // ✅ prevent overflow
  Reason: reason ? reason.label : "", // (not used but ok)
};

    api
      .AllDocDeleteAPI(cancelData)
      .then((res) => {
        console.log("Delete API raw response:", res);

        const result =
          res?.AllDocDeleteAPIjs?.Table?.[0]?.Result;

        if (result === "Success") {
          alert("Delete successful");

          // optional: refresh list or go back
          setView("Cancel");
        } else {
          alert("Delete failed");
        }
      })
      .catch((err) => console.error(err));
  };

  return (
    <div className="max-w-4xl p-8 mx-auto mt-10 font-sans border border-gray-200 shadow-lg bg-gradient-to-br from-gray-50 to-white rounded-2xl">
      <h2 className="mb-8 text-2xl font-bold text-gray-800">
        Cancel Document
      </h2>

      {/* DocType */}
      <div className="flex items-center mb-6">
        <label className="w-32 font-semibold text-gray-900">DocType</label>
        <div className="flex-1 mr-4">
          <Select
            className="react-select-container"
            classNamePrefix="react-select"
            options={docTypeOptions}
            value={docType}
            onChange={setDocType}
            placeholder="Select DocType"
            isClearable
          />
        </div>
        <button
          className="px-3 py-1 text-white transition bg-blue-600 rounded-lg shadow hover:bg-blue-700"
          onClick={handleProcess}
        >
          Process
        </button>
      </div>

      {/* DocNo */}
      <div className="flex items-center mb-6">
        <label className="w-32 font-semibold text-gray-900">DocNo</label>
        <div className="flex-1 mr-4">
          <Select
            options={docNoOptions}
            value={docNo}
            onChange={setDocNo}
            placeholder="Select DocNo"
            isClearable
          />
        </div>
        <button
          className="px-3 py-1 text-white transition bg-indigo-600 rounded-lg shadow hover:bg-indigo-700"
          onClick={handleVerify}
        >
          Verify
        </button>
      </div>


      {/* Reason */}
      <div className="flex items-center mb-6">
        <label className="w-32 font-semibold text-gray-900">Reason</label>
        <div className="flex-1">
          <Select
            options={reasonOptions}
            value={reason}
            onChange={setReason}
            placeholder="Select Reason"
            isClearable
          />
        </div>
      </div>

      {/* Cancel By */}
      <div className="flex items-center mb-6">
        <label className="w-32 font-semibold text-gray-900">Cancel By</label>
        <div className="flex-1">
          <Select
            options={cancelByOptions}
            value={cancelBy}
            onChange={setCancelBy}
            placeholder="Select Cancel By"
            isClearable
          />
        </div>
      </div>

      {/* Remark + Delete */}
      <div className="flex items-center">
        <label className="w-32 font-semibold text-gray-900">Remark</label>
        <input
          className="flex-1 p-2 mr-4 border rounded-lg focus:ring focus:ring-blue-200"
          value={remark}
          onChange={(e) => setRemark(e.target.value)}
        />
        <button
          className="px-3 py-1 text-white transition bg-red-600 rounded-lg shadow hover:bg-red-700"
          onClick={handleDelete}
        >
          Delete
        </button>

      </div>
    </div>
  );
}

export default CancelListpage;
